'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Feedback-module_submittedContainer__bdnl-{display:grid;grid-template-columns:repeat(12,1fr)}.Feedback-module_submittedContent__jY5DD{grid-column:span 12}.Feedback-module_csLink__WS37d{margin-top:.25rem}";
var styles = {"submittedContainer":"Feedback-module_submittedContainer__bdnl-","submittedContent":"Feedback-module_submittedContent__jY5DD","csLink":"Feedback-module_csLink__WS37d"};
styleInject["default"](css_248z, '41ba6586-ff78-4280-a91c-26ef4b238657');

exports["default"] = styles;
